import React from "react";
import ImageG from "./image-g";
import PortableText from "./portableText";

interface ImageAsset {
  asset?: {
    _id?: string;
  };
  _rawCaption?: any[];
  alt?: string;
}

interface FigureGProps {
  node?: ImageAsset;
  nodeM?: ImageAsset;
  alt?: string;
}

const FigureG: React.FC<FigureGProps> = ({ node, nodeM, alt }) => {
  if (!node?.asset) {
    return null;
  }

  return (
    <>
      {node._rawCaption ? (
        <figure>
          <ImageG node={node} nodeM={nodeM} alt={alt} />
          <figcaption className="entry-content">
            <PortableText blocks={node._rawCaption} />
          </figcaption>
        </figure>
      ) : (
        <ImageG node={node} nodeM={nodeM} alt={alt} />
      )}
    </>
  );
};

export default FigureG;
